import { useTranslation } from "react-i18next";
import { FacebookSvg, SocialBtmPattern, SocialTopPattern, TwitterSvg, YoutubeSvg } from "../../../common/svg/AllSvg";
import { useEffect, useRef, useState } from "react";

const SocialMedia = () => {
    const { t } = useTranslation('common');
    const [height, setHeight] = useState<number>(0)
    const [height1, setHeight1] = useState<number>(0)
    const heightRef = useRef(null);
    const heightRef1 = useRef(null);

    useEffect(() => {
        // twitter latest timeline
        if (document) {
            var tag = document.createElement('script');
            tag.async = true;
            tag.src = 'https://platform.twitter.com/widgets.js';
            var body = document.getElementsByTagName('body')[0];
            body.appendChild(tag);
        }
    }, []);

    useEffect(() => {
        const heights: any = heightRef.current;
        if (!!heights) {
            setHeight(heights.scrollHeight)
        }
    }, [heightRef])

    useEffect(() => {
        const heights: any = heightRef1.current;
        if (!!heights) {
            setHeight1(heights.scrollHeight)
        }
    }, [heightRef1])

    return (
        <div className="w-full pt-[30px] lg:pt-[70px] xlx:pt-[80px] container flex flex-col gap-[25px] md:gap-[30px] xlx:gap-[40px]">
            <div className="flex flex-col gap-[2px] md:gap-[5px]">
                <h1 className="text-primaryText dark:text-white font-bold">{t("corporate.social_media.title")}</h1>
                <h5 className="text-blackDull dark:text-textBlackDull font-medium">{t("corporate.social_media.desc")}</h5>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 w-full gap-[25px] xlx:gap-[35px]">
                <div className="w-full h-[420px] xs:h-[450px] msm:h-[550px] xl:h-[520px] 1.5xl:h-[550px] border border-[#D9D9D9] dark:border-[#5f5e5e] bg-[#EEFEFA] dark:bg-bgDark rounded-tr-[20px] relative md:p-[20px] md:pt-[70px] p-[15px] pt-[65px]">
                    <div className="absolute top-[12px] left-[-9px]">
                        <div className="relative bg-[#473BF0] h-[40px] flex items-center pl-[22px] pr-[16px] justify-center gap-[10px] rounded-r-[10px] whitespace-nowrap text-white text-lg font-bold">
                            <FacebookSvg />
                            {t("corporate.social_media.facebook")}

                            <div className="absolute top-[-3px] left-0"><SocialTopPattern className="fill-[#1B1578]" /> </div>
                            <div className="absolute bottom-[-5px] left-0"><SocialBtmPattern className="fill-[#1B1578]" /> </div>
                        </div>
                    </div>

                    <div ref={heightRef} className="h-full rounded-[10px] bg-white dark:bg-blackDull">
                        <iframe
                            className="w-full h-full rounded-[14px]"
                            src={`https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmmrcmumbai&tabs=timeline&width=495&height=${height}&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`}
                            scrolling='no'
                            frameBorder='0'
                            allowFullScreen
                            allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
                            title="mmrcl"
                        />
                    </div>
                </div>

                <div className="w-full h-[420px] xs:h-[450px] msm:h-[550px] xl:h-[520px] 1.5xl:h-[550px] border border-[#D9D9D9] dark:border-[#5f5e5e] bg-[#EEFEFA] dark:bg-bgDark rounded-tr-[20px] relative md:p-[20px] md:pt-[70px] p-[15px] pt-[65px]">
                    <div className="absolute top-[12px] left-[-9px]">
                        <div className="relative bg-[#070427] h-[40px] flex items-center pl-[22px] pr-[16px] justify-center gap-[10px] rounded-r-[10px] whitespace-nowrap text-white text-lg font-bold">
                            <TwitterSvg />
                            {t("corporate.social_media.twitter")}

                            <div className="absolute top-[-3px] left-0"><SocialTopPattern className="fill-[#828282]" /> </div>
                            <div className="absolute bottom-[-5px] left-0"><SocialBtmPattern className="fill-[#828282]" /> </div>
                        </div>
                    </div>

                    <div className="h-full rounded-[10px] bg-white dark:bg-blackDull">
                        <div className="w-full h-full overflow-hidden overflow-y-scroll rounded-[10px]">
                            <a className="twitter-timeline" href="https://twitter.com/MumbaiMetro3?ref_src=twsrc%5Etfw"><h3 className="text-blackDark dark:text-textBlackDark font-bold p-[15px] xlx:p-[20px] text-base leading-snug">{t("passenger.home.social.twitter.tweets")}</h3></a> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                        </div>
                    </div>
                </div>

                <div className="w-full h-[420px] xs:h-[450px] msm:h-[550px] xl:h-[520px] 1.5xl:h-[550px] border border-[#D9D9D9] dark:border-[#5f5e5e] bg-[#EEFEFA] dark:bg-bgDark rounded-tr-[20px] relative md:p-[20px] md:pt-[70px] p-[15px] pt-[65px]">
                    <div className="absolute top-[12px] left-[-9px]">
                        <div className="relative bg-[#F03B3E] h-[40px] flex items-center pl-[22px] pr-[16px] justify-center gap-[10px] rounded-r-[10px] whitespace-nowrap text-white text-lg font-bold">
                            <YoutubeSvg />
                            {t("corporate.social_media.youtube")}

                            <div className="absolute top-[-3px] left-0"><SocialTopPattern className="fill-[#A71A1C]" /> </div>
                            <div className="absolute bottom-[-5px] left-0"><SocialBtmPattern className="fill-[#A71A1C]" /> </div>
                        </div>
                    </div>

                    <div ref={heightRef1} className="h-full rounded-[10px] bg-white dark:bg-blackDull w-full">
                        <iframe
                            style={{
                                width: "100%",
                                height: `${height1}px`,
                            }}
                            // src="https://www.youtube.com/embed/live_stream?channel=UC3iKloxfX33ZuRQ4SRc9Fbg"
                            src="https://www.youtube.com/embed/MeQDPXtm4-o"
                            title={t("corporate.social_media.mmrc_youtube")}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SocialMedia;